declare module 'src/admin/dispatch/dashboard.jsx' {
    var _: React.ComponentClass<any, any>;
}

